import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { fetchUsers } from 'store/actions';
import { Constants } from 'utilities/constants';

const systemUsers = [
  Constants.Username.AUTOCALC,
  Constants.Username.MLSFEED,
  Constants.Username.CRMFEED
];

// Multi-select over every ReVUe user (anyone who has signed in at least once), minus system users and any excluded ids.
// value/onChange work in user ids so callers never hold stale user objects.
const UserMultiSelect = ({ users, fetchUsers, value, onChange, excludeUserIds = [], label = 'Users', helperText, disabled }) => {
  useEffect(() => {
    if (!users?.length) {
      fetchUsers();
    }
  }, []);

  const options = useMemo(() => (users ?? [])
    .filter(user => !systemUsers.includes(user.name) && !excludeUserIds.includes(user.id))
    .sort((a, b) => (a.fullName ?? a.name ?? '').localeCompare(b.fullName ?? b.name ?? '')),
    [users, excludeUserIds]);

  const selectedOptions = useMemo(() => options.filter(user => value.includes(user.id)), [options, value]);

  return (
    <Autocomplete
      multiple
      disabled={disabled}
      options={options}
      value={selectedOptions}
      onChange={(e, selected) => onChange(selected.map(user => user.id))}
      getOptionLabel={user => user.fullName ?? user.name ?? ''}
      getOptionSelected={(option, selected) => option.id === selected.id}
      filterSelectedOptions
      renderInput={params => (
        <TextField
          {...params}
          variant='outlined'
          size='small'
          label={label}
          placeholder='Search users...'
          helperText={helperText}
        />
      )}
    />
  );
}

const mapStateToProps = state => ({
  users: state.appState.users
});

const mapDispatchToProps = {
  fetchUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMultiSelect);
